class ModelServiceAccount {

    id = null;
    status = null;
    rolus = null;
    member = null;
}


export default ModelServiceAccount;